<template>
  <div class="d-flex w-full h-full align-center justify-center h-full w-full">
    <iframe
      src="https://giphy.com/embed/3o6ZsW4XzMcebhkU2k"
      width="480"
      height="269"
      frameBorder="0"
      class="giphy-embed"
      allowFullScreen
    />
    <p>
      <a href="https://giphy.com/gifs/family-guy-fox-family-guy-foxtv-3o6ZsW4XzMcebhkU2k"
        >via GIPHY</a
      >
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'DashboardView',
  components: {},
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({})
  },
  mounted() {},
  methods: {}
};
</script>
